import { NodeSource, TreeOptions, TreeSource } from "@omegagrid/tree";
import { msg } from "@omegagrid/localize";
import { BrowserAdapter } from "@reporting/rp-app-host";
import { MODULE_CODES } from "@reporting/rp-types/accounting";

export class ItemsBrowserAdapter extends BrowserAdapter {

	constructor() { super() }

	async getTree(): Promise<TreeSource> {
		const treeItems: NodeSource[] = [];
		treeItems.push({
			k: `definition-dimensions-${MODULE_CODES.ITEMS}`,
			v: msg('Dimensions'),
			l: 0,
			icon: { icon: ['fas', 'cube'], color: '#9A2CA1' }
		}, {
			k: 'definition-itemIndicators',
			v: msg('Indicators'),
			l: 0,
			icon: { icon: 'gauge-max', color: 'Orange' }
		}, {
			k: 'definition-attributes-itemDetail',
			v: `${msg('Detail')} - ${msg('Attributes')}`,
			l: 0,
			icon: { icon: 'brackets-curly', color: 'GoldenRod' }
		}, {
			k: `definition-drillColumns-${MODULE_CODES.ITEMS}`,
			v: `${msg('Detail')} - ${msg('Columns')}`,
			l: 0,
			icon: { icon: 'table-list', color: 'DarkGreen' }
		}, {
			k: `definition-detailCustom-${MODULE_CODES.ITEMS}`,
			v: `${msg('Detail')} - ${msg('Custom')}`,
			l: 0,
			icon: { icon: 'shapes', color: 'Chocolate' }
		}, {
			k: `definition-securityRoles-${MODULE_CODES.ITEMS}`,
			v: msg('Security roles'),
			l: 0,
			icon: { icon: 'lock-keyhole', color: 'DarkSlateBlue' },
		});
		return treeItems;
	}

	getOptions(): Partial<TreeOptions> {
		return {
			selectMode: 'none',
			expanders: false,
		};
	}
}
